import React, { useState, Fragment, useEffect } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import { SuggestionDropDownModelPopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import moment from "moment";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import CustomSuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import SuperAdminSMS from "../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminNotification from "../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import { ORDER_TYPE_NAME } from "../../../../../enums/OrderEnums";
import { capitalize } from "lodash";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const ViewOpenIssuesTicketLeft = (props) => {
  //state
  const [open, setOpen] = useState(false);

  const [statusDropDownText, setStatusDropDownText] = useState("");
  const handleStatusChange = (e, type) => {
    e.preventDefault();
    //setOpen(false);
    setStatusDropDownText(type);
  };
  const handleShowStatusList = () => {
    setOpen(true);
  };
  const handleCloseStatusList = () => {
    setStatusDropDownText(props.issueDetails && props.issueDetails.status);
    setOpen(false);
  };

  const onConfirmClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setStatusDropDownText(props.issueDetails && props.issueDetails.status);
  }, [props.issueDetails && props.issueDetails.status]);

  const makeCallingObject = (data) => {
    let formData = {
      vendor_id: data?.vendor_id,
      restaurant_name: data?.restaurant_id?.restaurant_name,
      user_details: {
        country_code:
          data?.restaurant_id?.contact_detail &&
          data?.restaurant_id?.contact_detail[0]?.country_code,
        mobile_number:
          data?.restaurant_id?.contact_detail &&
          data?.restaurant_id?.contact_detail[0]?.mobile_no,
      },
    };
    return formData;
  };

  const makeSmsData = (data) => {
    let formData = {
      vendor_id: data?.vendor_id,
      restaurant_name: data?.restaurant_id?.restaurant_name,
      vendor: {
        country_code:
          data?.restaurant_id?.contact_detail &&
          data?.restaurant_id?.contact_detail[0]?.country_code,
        mobile_number:
          data?.restaurant_id?.contact_detail &&
          data?.restaurant_id?.contact_detail[0]?.mobile_no,
      },
    };
    return formData;
  };

  const makeNotificationData = (data) => {
    let formData = {};
    formData.vendor_id = data?.vendor_id;
    formData.restaurant_name = data?.restaurant_id?.restaurant_name;
    return formData;
  };

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };

  return (
    <React.Fragment>
      {/* {console.log("Send Data Props ===>", props?.sendDataProps)} */}
      <div className="open_issues_view_tickets_left">
        <Row>
          <Col md={3} xs={3}>
            <div className="f10-400 mb-2 text-gray">Request Number</div>
            <div className="f12-500">
              {props?.issueDetails?.itemType === "SEATING"
                ? props?.issueDetails?.diner_id?.diner_id
                : props?.issueDetails?.itemType === "SCAN"
                ? props?.issueDetails?.itemId?.transactionalNumber
                : props?.issueDetails?.itemType === "ORDER"
                ? props?.issueDetails?.itemId?.order_id
                : props?.issueDetails?.itemType === "EXP"
                ? props?.issueDetails?.itemId?.requestId
                : "N/A"}
            </div>
          </Col>
          <Col md={3} xs={3}>
            <div className="f10-400 mb-2 text-gray">Request Type</div>
            <div className="f12-500">
              {props?.issueDetails?.itemType === "SEATING"
                ? props.issueDetails?.diner_id?.service_type
                : props?.issueDetails?.itemType === "SCAN"
                ? props?.issueDetails?.itemId?.transaction_type
                : props?.issueDetails?.itemType === "ORDER"
                ? ORDER_TYPE_NAME[props?.issueDetails?.itemId?.order_type]
                : props?.issueDetails?.itemType === "EXP"
                ? "Experience"
                : "N/A"}
            </div>
          </Col>
          <Col md={3} xs={3}>
            <div className="f10-400 mb-2 text-gray">Issue Category</div>
            <div className="f12-500">
              {props?.issueDetails?.itemType === "EXP"
                ? capitalize(props?.issueDetails?.itemId?.expType) + " "
                : null}
              {props.issueDetails &&
                props.issueDetails?.ticket_sub_category_id?.title}
            </div>
          </Col>
          <Col md={3} xs={3}>
            <div className="f10-400 mb-2">Status</div>
            <div className="mb-2 text-white f9-700 bg-yellow enlblSelect">
              {calcStatus(props.issueDetails && props.issueDetails.status)}
              <SuggestionDropDownModelPopup
                onOpenModal={handleShowStatusList}
                status={statusDropDownText}
                open={open}
                displayButtonThree={true}
                displayButtonFour={true}
                displayButtonFive={true}
                displayButtonSix={true}
                onCloseModal={handleCloseStatusList}
                buttonTitle="Suggestion Status"
                buttonText="Suggestion Status"
                headerText="Suggestion Status"
                timeTextOne="New"
                timeTextTwo="In-Progress"
                timeTextThree="Awaiting - Feedback"
                timeTextFour="On-Hold"
                timeTextFive="Re-Opened"
                timeTextSix="Resolved"
                timeTextSeven="Closed"
                timeTextEight="Archive"
                timeTextNine="Called User"
                timeTextTen="Completed"
                timeOneClick={(e) => handleStatusChange(e, 0)}
                timeTwoClick={(e) => handleStatusChange(e, 1)}
                timeThreeClick={(e) => handleStatusChange(e, 2)}
                timeFourClick={(e) => handleStatusChange(e, 3)}
                timeFiveClick={(e) => handleStatusChange(e, 4)}
                timeSixClick={(e) => handleStatusChange(e, 5)}
                timeSevenClick={(e) => handleStatusChange(e, 6)}
                timeEightClick={(e) => handleStatusChange(e, 7)}
                timeNineClick={(e) => handleStatusChange(e, 8)}
                timeTenClick={(e) => handleStatusChange(e, 9)}
                onSubmit={
                  props &&
                  props.onSubmit &&
                  props.onSubmit(statusDropDownText, onConfirmClose)
                }
              />
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={props?.issueDetails?.itemType === "EXP" ? 4 : 6} xs={6}>
            <div className="f10-400 mb-2 text-gray">Issue Date</div>
            <div className="f12-500">
              {moment(
                props.issueDetails && props.issueDetails.createdAt
              ).format("Do MMM YYYY")}
            </div>
          </Col>
          {props?.issueDetails?.itemType === "EXP" ? (
            <Col md={4} xs={6}>
              <div className="f10-400 mb-2 text-gray">Event Date</div>
              <div className="f12-500">
                {moment(props?.issueDetails?.itemId?.reservationTime).format(
                  "Do MMM YYYY"
                )}
              </div>
            </Col>
          ) : null}
          <Col md={props?.issueDetails?.itemType === "EXP" ? 4 : 6} xs={6}>
            <div className="f10-400 mb-2 text-gray">User Email ID</div>
            <div className="f12-500">
              {props?.issueDetails?.user_id?.email !== undefined &&
              props?.issueDetails?.user_id?.email !== null &&
              props?.issueDetails?.user_id?.email !== ""
                ? props?.issueDetails?.user_id?.email
                : "_"}
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={3} xs={3}>
            <div className="f10-400 mb-2 text-gray">User Name</div>
            <div className="d-flex flex-column align-items-center">
              <div className="enIMG33 rounded-circle">
                {props.issueDetails &&
                props.issueDetails.user_id &&
                props.issueDetails.user_id.profile_photo &&
                props.issueDetails.user_id.profile_photo.length >= 1 ? (
                  <Image
                    fluid
                    src={props.issueDetails.user_id.profile_photo[0]}
                    alt="Icon"
                  />
                ) : (
                  <Image
                    fluid
                    src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                    alt="Icon"
                  />
                )}
              </div>
              <div className="f12-400 pt-2">
                {" "}
                {props.issueDetails &&
                  props.issueDetails.user_id &&
                  props.issueDetails.user_id.first_name}
              </div>
            </div>
          </Col>
          <Col md={9} xs={9}>
            <div className="f10-400 mb-2 text-gray">Issue Description</div>
            <div className="f12-500">
              {props.issueDetails && props.issueDetails.description}
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={12} xs={12}>
            <div className="f11-400 mb-2 text-gray">Photos</div>
            <div className="d-flex flex-wrap">
              {props.issueDetails &&
              props.issueDetails.refrence_images &&
              props.issueDetails.refrence_images[0] ? (
                <SimpleReactLightbox>
                  <SRLWrapper options={options}>
                    <div className="d-flex flex-wrap">
                      {props.issueDetails &&
                        props.issueDetails.refrence_images &&
                        props.issueDetails.refrence_images.map(
                          (photos, index) => {
                            return (
                              <div
                                className="enIMG97 w-25 h-25 mr-2 mb-2"
                                key={index}
                              >
                                <Image
                                  fluid
                                  src={photos}
                                  alt="image"
                                  className="w-100 h-100 img-thumbnail"
                                />
                              </div>
                            );
                          }
                        )}
                    </div>
                  </SRLWrapper>
                </SimpleReactLightbox>
              ) : (
                <Fragment>
                  <p className="f10-500">Image not available</p>
                </Fragment>
              )}
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={12} xs={12}>
            <div className="f11-400 mb-2 text-gray">Video</div>
            {(props.issueDetails &&
              props.issueDetails.refrence_videos &&
              props.issueDetails.refrence_videos.length <= 0) ||
            (props.issueDetails &&
              props.issueDetails.refrence_videos &&
              props.issueDetails.refrence_videos[0] === "") ? (
              <div className="f12-500">Video Not Available</div>
            ) : (
              <div className="row">
                {props.issueDetails &&
                  props.issueDetails.refrence_videos &&
                  props.issueDetails.refrence_videos.map((video, index) => {
                    return (
                      <div className="col-4 mb-3" key={index}>
                        <video
                          width="150"
                          height="100"
                          controls
                          src={video && video}
                          type="video/mp4"
                        />
                      </div>
                    );
                  })}
              </div>
            )}
          </Col>
        </Row>
        <hr />
        {props.displayRestaurantDetails ? (
          <Row>
            <Col md={4} xs={4} className="d-flex flex-column align-items-start">
              <div className="f12-500 mb-2">Restaurant Name</div>
              <div className="d-flex flex-column align-items-center">
                <div className="enImage45 rounded-circle">
                  <SimpleReactLightbox>
                    <SRLWrapper options={options}>
                      <Image
                        //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                        src={
                          props.issueDetails &&
                          props.issueDetails.restaurant_id &&
                          props.issueDetails.restaurant_id.logo_url
                        }
                        alt="View"
                        title="View"
                        fluid
                        className="w-100 h-100"
                      />
                    </SRLWrapper>
                  </SimpleReactLightbox>
                </div>
                <div className="f14-500 text-center mt-1">
                  {" "}
                  {props.issueDetails &&
                    props.issueDetails.restaurant_id &&
                    props.issueDetails.restaurant_id.restaurant_name}
                </div>
              </div>
            </Col>
            <Col md={4} xs={4}>
              <div className="f12-500 mb-2">Address</div>
              <div className="f11-400 mb-2">
                {props.issueDetails &&
                  props.issueDetails.restaurant_id &&
                  props.issueDetails.restaurant_id.restaurant_address}
              </div>
            </Col>
            <Col md={4} xs={4}>
              <div className="f12-500 mb-2">Restaurant Number</div>
              <div className="f11-400 mb-3">
                {props.issueDetails &&
                  props.issueDetails.restaurant_id &&
                  props.issueDetails.restaurant_id.contact_detail.map(
                    (number, index) => {
                      return (
                        <React.Fragment key={index}>
                          <li type="none">
                            {number.country_code + " " + number.mobile_no}
                          </li>
                        </React.Fragment>
                      );
                    }
                  )}
              </div>
              <div className="d-flex">
                <CallingButtonPopup
                  sendData={makeCallingObject(props.issueDetails)}
                  actionBy="ADMIN"
                />
                <SuperAdminSMS
                  dataSend={makeSmsData(props.issueDetails)}
                  actionBy="ADMIN"
                />
                <SuperAdminNotification
                  dataSend={makeNotificationData(props.issueDetails)}
                  actionBy="ADMIN"
                />
              </div>
            </Col>
            <Col md={4} xs={4}>
              <div className="f12-500 mb-2">Hours Of Operation</div>
              <div className="f11-400 mb-2">
                Closes: {props?.issueDetails?.restaurant_id?.closingTime}
              </div>
            </Col>
            <Col md={4} xs={4}>
              <div className="f12-500 mb-2">City</div>
              <div className="f11-400 mb-2">
                {" "}
                {props.issueDetails &&
                  props.issueDetails.restaurant_id &&
                  props.issueDetails.restaurant_id.city}
              </div>
            </Col>
          </Row>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};
